module.exports = __webpack_public_path__ + "static/media/skincare_leaflet@3x.b6a8e980.png";